import { validateBrikksByPersonalNumber, validateBrikksByAgreements } from 'utils/validation/brikks';

export const validateBrikks = (brikks, personalNumber, agreements) => {
  const validatedByPersonalNumber = validateBrikksByPersonalNumber(brikks, personalNumber);
  const validatedByAgreements = validateBrikksByAgreements(validatedByPersonalNumber, agreements);

  return validatedByAgreements;
};
